function isObject(obj) {
    return obj !== null && typeof obj === 'object';
}
function isValidMap(map) {
    return Array.isArray(map) || isObject(map);
}
function normalizeMap(map) {
    if (!isValidMap(map)) {
        return [];
    }
    return Array.isArray(map)
        ? map.map(key => ({ key, val: key }))
        : Object.keys(map).map(key => ({ key, val: map[key] }));
}

export const mapState = states => {
    const res = {};
    if (!isValidMap(states)) {
        console.error(
            '[vuex] mapState: mapper parameter must be either an Array or an Object'
        );
    }
    normalizeMap(states).forEach(({ key, val }) => {
        res[key] = function mappedState() {
            const module =
                this.$store._modulesNamespaceMap[`${this.$storeName}/`];
            if (!module) {
                return null;
            }
            const state = module.context.state;
            const getters = module.context.getters;
            return typeof val === 'function'
                ? val.call(this, state, getters)
                : state[val];
        };
        // mark vuex getter for devtools
        res[key].vuex = true;
    });
    return res;
};
export const mapGetters = getters => {
    const res = {};
    if (!isValidMap(getters)) {
        console.error(
            '[vuex] mapGetters: mapper parameter must be either an Array or an Object'
        );
    }
    normalizeMap(getters).forEach(({ key, val }) => {
        res[key] = function mappedGetter() {
            return this.$store.getters[`${this.$storeName}/${val}`];
        };
        res[key].vuex = true;
    });
    return res;
};

export const mapMutations = mutations => {
    const res = {};
    if (!isValidMap(mutations)) {
        console.error(
            '[vuex] mapMutations: mapper parameter must be either an Array or an Object'
        );
    }
    normalizeMap(mutations).forEach(({ key, val }) => {
        res[key] = function mappedMutation(...args) {
            let commit = this.$store.commit;
            const module =
                this.$store._modulesNamespaceMap[`${this.$storeName}/`];
            if (!module) {
                return;
            }
            commit = module.context.commit;
            return typeof val === 'function'
                ? val.apply(this, [commit].concat(args))
                : commit.apply(this.$store, [val].concat(args));
        };
    });
    return res;
};

export const mapActions = actions => {
    const res = {};
    if (!isValidMap(actions)) {
        console.error(
            '[vuex] mapActions: mapper parameter must be either an Array or an Object'
        );
    }
    normalizeMap(actions).forEach(({ key, val }) => {
        res[key] = function mappedAction(...args) {
            let dispatch = this.$store.dispatch;
            const module =
                this.$store._modulesNamespaceMap[`${this.$storeName}/`];
            if (!module) {
                return;
            }
            dispatch = module.context.dispatch;
            return typeof val === 'function'
                ? val.apply(this, [dispatch].concat(args))
                : dispatch.apply(this.$store, [val].concat(args));
        };
    });
    return res;
};

export const mergeModules = (...args) => {
    return store => {
        const searchCenter = store.state.common.isSearchCenter;
        const ret = {
            namespaced: true,
            state: {},
            getters: {},
            mutations: {},
            actions: {}
        };
        const keys = ['state', 'getters', 'mutations', 'actions'];
        args.forEach(m => {
            if (typeof m === 'function') m = m(store);
            keys.forEach(k => {
                ret[k] = {
                    ...ret[k],
                    ...(typeof m[k] === 'function'
                        ? m[k]({ searchCenter })
                        : m[k] || {})
                };
            });
        });
        const initState = ret.state;
        ret.state = function () {
            return { ...initState };
        };
        return ret;
    };
};
